var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    {
      staticClass: "login-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      !_vm.formState.processing &&
      (_vm.formState.message.length > 0 || _vm.formState.success)
        ? _c(
            "b-alert",
            { attrs: { variant: _vm.formAlertType, show: "" } },
            [
              _vm.formState.success
                ? [
                    _c("p", [
                      _vm._v(
                        "We have sent an email with instructions to reset your password."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "If you don't get it, please verify you entered a correct email address or check your spam folder"
                      ),
                    ]),
                  ]
                : [
                    _vm._v(
                      "\n      " + _vm._s(_vm.formState.message) + "\n    "
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Email address" } },
        [
          _c("b-form-input", {
            attrs: { type: "text", state: _vm.emailInvalid },
            model: {
              value: _vm.formData.email,
              callback: function ($$v) {
                _vm.$set(
                  _vm.formData,
                  "email",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "formData.email",
            },
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.emailInvalid } },
            [_vm._v("\n      " + _vm._s(_vm.formValidation.email) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "login-submit",
          attrs: {
            type: "submit",
            variant: "primary",
            block: "",
            disabled: _vm.formState.processing,
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(!_vm.formState.processing ? "Submit" : "Processing...") +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }